import SampleForm from './SampleForm.js'

const FormIndex = {
  sample: SampleForm
};

export default FormIndex;